
import { mapState } from 'vuex'

import NavLink from './NavLink'
import Icon from '../../../common/Icon'

export default {
  name: 'MainNav',
  components: {
    NavLink,
    Icon
  },
  props: {
    logo: Object,
    menu: Array,
    config: Object,
  },
  computed: {
    ...mapState([ 'appInfo', 'user', 'showNav']),
    ...mapState({
      rewards: state => state.members.rewards,
    }),
    points() {
      if (this.rewards && this.rewards.points) {
        return this.rewards.points.toLocaleString('en-US')
      }
      return 0
    },
    pointsText() {
      if (this.config?.greetings?.points?.pointsText) {
        return !!this.points && this.config.greetings.points.pointsText
      }
      if (this.rewards && this.rewards.units) {
        return this.rewards.units
      }
      return this.points ? 'Points' : 'Point'
    },
  },
  methods: {
    toggleNav() {
      document.body.style.overflow = !this.showNav ? 'hidden' : 'auto'
      this.$store.commit('setShowNav', !this.showNav)
    },
    runCallback(callback) {
      this.toggleNav()
      return callback()
    },
    buttonClass(name) {
      if (name) {
        return this.$utils.kebab(name)
      }

      return ''
    },
  },
}
